import React, { Fragment } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Switch } from '@material-ui/core';
import Loading from '../../../../flowtrace-components/Loading'
import navItems from '../../../../layout-components/Sidebar/navItems'
import accountAPI from '../../../../flowtrace-api/Account/propertyActions';

export default function RoleNavigationConfiguration(props) {
  const accountNaviConfig = props.account && props.account.properties.find(p => p.navigationFilter) ? props.account.properties.find(p => p.navigationFilter).navigationFilter : [];

  const [saveInProgress, setSaveInProgress] = React.useState(false);
  const [naviConfig, setNaviConfig] = React.useState(accountNaviConfig);
  const [change, setChange] = React.useState(false);

  const [saveError, setSaveError] = React.useState(null);
  const [saveSuccess, setSaveSuccess] = React.useState(null);

  const naviSelected = (e) => {
    if(e.target.checked){
      setNaviConfig(naviConfig.filter(item => item !== e.target.id));
    } else {
      setNaviConfig([...new Set([...naviConfig, e.target.id])]);
    }
    setChange(true);
  }

  const deleteCall = async() => await accountAPI.deleteProperty(props.flowtraceUser.account.account_id, {navigationFilter:accountNaviConfig})
  const updateCall = async() => await accountAPI.addProperty(props.flowtraceUser.account.account_id, {navigationFilter:naviConfig})
  const handleSave = async() => {
    try {
      setSaveInProgress(true);
      setSaveSuccess(null);

      let response = {};
      if(naviConfig.length > 0) {
        if(accountNaviConfig.length > 0)
          await deleteCall(); // Need to remove the previous copy before adding a new one
        response = await updateCall();
      }
      else
        response = await deleteCall();

      if (!response.success){
        setSaveError("Error: " + response.message + " Please try again later or contact your account manager.")
      } else
        props.onClose();
    }
    catch (e) {
      console.error("Update Failed:", e.message)
      setSaveError("Problem during the navigation tree update: " + e.message)
    }
    setSaveInProgress(false)
  };

  const selectOptions = [];
  const allNaviOptions = navItems(props.flowtraceUser).availableNaviFilters();

  allNaviOptions.forEach((item) => {
    selectOptions.push(
      <Grid item xs={12} md={12} key={item.id+"grid"}>
        <Grid container spacing={1}>
          <Grid item xs={8} md={8}>
            <div className="font-size-md d-flex align-items-center justify-content-left pt-2">
              {item.label}
            </div>
          </Grid>
          <Grid item xs={4} md={4}>
            <Switch key={item.id+"switch"} id={item.id} checked={!naviConfig.includes(item.id)} disabled={saveInProgress} onChange={naviSelected} color="primary" name="enabled" inputProps={{ 'aria-label': 'primary checkbox' }} />
          </Grid>
        </Grid>
      </Grid>
    )
  });

  return (
    <Fragment>
      <Dialog open={props.dialogState} onClose={() => { props.onClose(); }} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Account's Navigation Menu (Items enabled/disabled):</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            {selectOptions}
          </Grid>
          <DialogContentText className="text-success"> {saveSuccess}</DialogContentText>
          <DialogContentText className="text-danger"> {saveError}</DialogContentText>
          <div>
            {saveInProgress ? <Loading minimize/> : null }
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={ handleSave } variant={"contained"} disabled={!change || saveInProgress} color="primary"> Save </Button>
          <Button onClick={() => { props.onClose(); }} disabled={saveInProgress} color="primary"> Close </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  )
}
